import { SolutionLanding } from "./SolutionLanding";

export default function FamilyLawDivorce() {
  return (
    <SolutionLanding
      meta={{
        testid: "family-landing-page",
        title: "WhatsApp Evidence for Divorce & Family Court | AuditPDF",
        description:
          "Turn a WhatsApp export into a timestamped PDF for divorce, custody, and maintenance hearings. Voice notes are transcribed offline, and a SHA-256 hash ties the bundle to the original file.",
        path: "/whatsapp-evidence-divorce-family-court",
      }}
      hero={{
        eyebrow: "For Family Court, Divorce & Custody",
        headline: "Print Admissible WhatsApp Evidence for Family Court & Divorce.",
        sub: "Stop filing cropped screenshots. Upload the WhatsApp export and download a chronological PDF a solicitor can put in the bundle, including transcribed voice notes.",
      }}
      pain={{
        title: "A handful of screenshots is the first thing the other side attacks.",
        points: [
          {
            title: "Cherry-picked screenshots",
            body: "Cropped images leave out what came before and after. Opposing counsel can say the thread was edited, and the hearing stalls on authenticity instead of the facts.",
          },
          {
            title: "Voice notes a judge cannot play",
            body: "Threats, arguments, and arrangements often sit in voice messages. A USB stick of audio is awkward in court. A transcript next to the message is not.",
          },
          {
            title: "Hours of screenshots",
            body: "Photographing hundreds of messages breaks the timeline, drops dates, and still looks incomplete. The €29 export replaces that pile with one numbered PDF.",
          },
        ],
      }}
      solution={{
        title: "The whole export, in order, tied to the file you uploaded.",
        body: "AuditPDF reads the native WhatsApp export and rebuilds the conversation in order. Nothing is summarised by an AI. A SHA-256 hash binds the PDF to that exact source file, so a claim that messages were added or removed can be checked.",
        bullets: [
          "Full export, not a selection: The transcript follows the source file, including system events, so gaps are visible instead of hidden.",
          "Offline voice-note transcription: Voice messages are transcribed on the processing machine. The audio is not sent to a cloud speech API.",
          "SHA-256 of the source: The bundle records a fingerprint of the export you uploaded, so the timeline can be tied back to that file.",
          "Zero retention: The upload and the PDF are deleted after the download window. The chat is not kept for a later case.",
        ],
        caseLabel: "FAMILY / EXHIBIT",
      }}
      showAffidavit={true}
      workflowSteps={[
        {
          title: "Upload",
          body: "Export the chat from WhatsApp and upload the zip as it came off the phone. Do not delete messages to make the thread look cleaner.",
        },
        {
          title: "Process",
          body: "The engine lays the messages out in order, transcribes voice notes, and hashes the source file. It does not rewrite what was said.",
        },
        {
          title: "Download & Purge",
          body: "Download the PDF bundle from a link that expires. The source export and the generated file are then deleted.",
        },
      ]}
      finalCta={{
        headline: "Bring the thread, not a folder of screenshots.",
        sub: "One export. One chronological PDF. €29 for a single conversation archive.",
      }}
      crossLink={{ to: "/whatsapp-evidence-tenancy-disputes", label: "For tenancy disputes" }}
    />
  );
}
